import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import {
  Form,
  Input,
  Button,
  Col,
  DatePicker,
  Icon,
  Statistic,
  Slider,
} from 'antd';
import Row from './Row';
import Card from './Card';
import Spacer from './Spacer';
import ReactTable from './ReactTable';
import Select from './Select';
import {
  fetchOptionsLike,
} from '../pages/ducks';
class StatusTaggingFormTransmittal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sizeState: 50,
      saveTrackingNumbers: null,
      isFetching: false,
      selectedDriver: null,
      selectedHelper: null,
      selectedVehicle: null,
      options: {
        courier: [],
        vehicle:[],
      },
    };

    this.validateTrackingNumber = this.validateTrackingNumber.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
    this.searchOption = this.searchOption.bind(this);

  }
searchOption(type, e) {
    const { doFetchOptionsLike } = this.props;

    this.setState({
      isFetching: true,
    });

    doFetchOptionsLike(type, e).then((action) => {
      this.setState(prevState => ({
        options: {
          ...prevState.options,
          [type]: action.payload.data.slice(0, 50),
        },
        isFetching: false,
      }));
    });
  }
  driverSelectHandler(value){
  this.setState({selectedDriver: value});

}
helperSelectHandler(value){
  this.setState({selectedHelper: value});

}
vehicleSelectHandler(value){
  this.setState({selectedVehicle: value});

}
  validateTrackingNumber(e) {
    e.preventDefault();
    const { form, validateHandler } = this.props;

    const { validateFields, setFieldsValue } = form;

    // eslint-disable-next-line no-unused-vars
    validateFields(
      [
        'reason',
        'trackingNumber',
        'comment',
        'timestamp',
        'received_by',
        'reference',
      ],
      (err, values) => {
        if (!err) {
          validateHandler(values);
          setFieldsValue({
            trackingNumber: '',
          });

          this.setState({ saveTrackingNumbers: values.trackingNumber });
        }
      },
    );
  }

  formSubmit(e) {
    e.preventDefault();

    const { form, submitHandler } = this.props;

    const { validateFieldsAndScroll } = form;

    // eslint-disable-next-line no-unused-vars
    validateFieldsAndScroll(
      ['comment', 'dateFrom', 'dateTo', 'mode'],
      (err, values) => {
        if (!err) {
          submitHandler(values);
          form.resetFields();
        }
      },
    );
  }
  tnKeyPressed(value){
    if(value.key === 'Enter'){
      this.validateTrackingNumber(value);
    }
  }
  render() {
    const {
      form,
      hasDatePicker,
      cardExtra,
      hasReceiver,
      isFailedStatus,
      hasDropdownReference,
      isFailedStatusRefusal,
      hasReference,
      hasTransmittalMode,
      trackingNumberList,
      trackingNumberListColumns,
      submitHandlerRefusal,
      errorList,
      successList,
      inputDisabled,
      saveTrackingNumber,
      errorMessageDispatch,
      doPreventDuplicate,
      successColumns,
    } = this.props;
    const { getFieldDecorator } = form;
    const { sizeState, saveTrackingNumbers,options,isFetching } = this.state;

    return (
      <div className="StatusTaggingForm">
        <Card title="Tracking Number Form" extra={cardExtra}>
          <Form onSubmit={this.validateTrackingNumber}>
            {hasTransmittalMode ? (
              <Row>
                <Col xs={24} sm={24} lg={8}>
                <Form.Item label="Driver">
                    {getFieldDecorator('dateFrom', {
                      rules: [
                        { required: true, message: 'Driver cannot be blank.' },
                      ],
                    })(
                      <Select
                                                              allowClear
                                                              loading={isFetching}
                                                              options={options.courier}
                                                              onSearch={e => this.searchOption('courier', e)}
                                                              onChange={(event) => this.driverSelectHandler(event)}
                                                              filterOption={false}
                                                              placeholder="Type to search for desired driver"
                                                              showSearch
                                                            />
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} lg={8}>
                  <Form.Item label="Helper">
                    {getFieldDecorator('dateTo', {
                      rules: [
                        // { required: true, message: 'Driver cannot be blank.' },
                      ],
                    })(
                      <Select
                                                              allowClear
                                                              loading={isFetching}
                                                              options={options.courier}
                                                              onSearch={e => this.searchOption('courier', e)}
                                                              onChange={(event) => this.helperSelectHandler(event)}
                                                              filterOption={false}
                                                              placeholder="Type to search for desired driver"
                                                              showSearch
                                                            />
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} lg={8}>
                  <Form.Item label="Select Vehicle">
                  {getFieldDecorator('mode', {
                      rules: [
                        { required: true, message: 'Driver cannot be blank.' },
                      ],
                    })(
                                                            <Select
                                                                allowClear
                                                                loading={isFetching}
                                                                options={options.vehicle}
                                                                onSearch={e => this.searchOption('vehicle', e)}
                                                                onChange={(event) => this.vehicleSelectHandler(event)}
                                                                filterOption={false}
                                                                placeholder="Type to search for desired vehicle"
                                                                showSearch
                                                                 style={{ width: 300 }}/>)}
                                                                 </Form.Item>
                </Col>
              </Row>
            ) : null}
            <Row>
              <Col xs={24} sm={12} lg={hasDatePicker ? 12 : 24}>
                <Form.Item label={hasTransmittalMode ? 'Remarks' : 'Comment'}>
                  {getFieldDecorator('comment', {
                    rules: [
                      { required: false, message: 'Comment cannot be blank.' },
                    ],
                  })(
                    <Input
                      name="comment"
                      placeholder={
                        hasTransmittalMode ? 'Enter remarks' : 'Enter comment'
                      }
                      autoComplete="off"
                    />,
                  )}
                </Form.Item>
              </Col>
              {hasDatePicker ? (
                <Col xs={24} sm={12} lg={12}>
                  <Form.Item label="Timestamp">
                    {getFieldDecorator('timestamp', {
                      rules: [
                        {
                          required: false,
                          message: 'Timepicker cannot be blank.',
                        },
                      ],
                    })(
                      <DatePicker
                        placeholder="Select timestamp"
                        style={{ width: '100%' }}
                        showTime={{
                          hideDisabledOptions: true,
                          defaultValue: [moment('00:00', 'HH:mm')],
                        }}
                      />,
                    )}
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}
            </Row>
            <Row>
              {hasReceiver ? (
                <Col>
                  <Form.Item label="Received By">
                    {getFieldDecorator('received_by', {
                      rules: [
                        {
                          required: true,
                          message: 'Received By cannot be blank.',
                        },
                      ],
                    })(<Input placeholder="Enter received by" />)}
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}
            </Row>
            {isFailedStatus ? (
              <Row>
                <Col>
                  <Form.Item label="Reason">
                    {getFieldDecorator('reason', {
                      rules: [
                        { required: true, message: 'Reason cannot be blank.' },
                      ],
                    })(
                      <Select
                        options={options}
                        name="reason"
                        placeholder="Select reason"
                      />,
                    )}
                  </Form.Item>
                </Col>
              </Row>
            ) : null}
            {isFailedStatusRefusal ? (
              <Row>
                <Col>
                  <Form.Item label="Reason">
                    {getFieldDecorator('reason', {
                      rules: [
                        { required: true, message: 'Reason cannot be blank.' },
                      ],
                    })(
                      <Select
                        options={options}
                        name="reason"
                        placeholder="Select reason"
                      />,
                    )}
                  </Form.Item>
                </Col>
              </Row>
            ) : null}
            {hasDropdownReference ? (
              <Row>
                <Col>
                  <Form.Item label="Reference">
                    {getFieldDecorator('reference', {
                      rules: [
                        { required: true, message: 'Reference cannot be blank.' },
                      ],
                    })(
                      <Select
                        options={options}
                        name="reference"
                        placeholder="Select reference"
                      />,
                    )}
                  </Form.Item>
                </Col>
              </Row>
            ) : null}
            {hasReference ? (
              <Row>
                <Col>
                  <Form.Item label="Reference">
                    {getFieldDecorator('reference', {
                      rules: [
                        {
                          required: true,
                          message: 'Reference cannot be blank.',
                        },
                      ],
                    })(<Input placeholder="Enter reference" />)}
                  </Form.Item>
                </Col>
              </Row>
            ) : null}

            <Row>
              <Col>
                <Form.Item label="Tracking Number">
                  {getFieldDecorator('trackingNumber', {
                    rules: [
                      {
                        required: true,
                        message: 'Tracking Number cannot be blank.',
                      },
                    ],
                  })(
                    <Input.TextArea
                      name="trackingNumber"
                      onPressEnter={
                        doPreventDuplicate ? this.validateTrackingNumber : false
                      }
                      onKeyPress={e=> this.tnKeyPressed(e)}
                      placeholder="Enter tracking number(s)"
                      disabled={inputDisabled}
                    />,
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button
                  htmlType="submit"
                  type="primary"
                  disabled={inputDisabled}
                  block
                >
                  <Icon viewBox="0 0 1024 1024">
                    <FontAwesomeIcon icon={faPlus} fixedWidth />
                  </Icon>
                  Add Tracking Number
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
        {
          /* eslint-disable */
          saveTrackingNumber ? (
          saveTrackingNumbers ? (
            <React.Fragment>
              {/* {console.log(errorMessageDispatch)} */}
              <Spacer />
              <Card>
                <Row>
                  <Col
                    style={{
                      backgroundColor:
                        errorMessageDispatch !== ' ' ? 'red' : null,
                    }}
                    xs={24}
                    sm={24}
                    lg={sizeState > 30 ? 24 : 8}
                  >
                    <Statistic
                      style={{ textAlign: 'center' }}
                      value={`${saveTrackingNumbers}`}
                      valueStyle={{
                        fontSize: `${sizeState}0%`,
                        textAlign: 'center',
                        color: errorMessageDispatch !== ' ' ? 'white' : 'black',
                      }}
                    />
                  </Col>
                  <Col xs={24} sm={24} lg={sizeState > 30 ? 24 : 8} style={{
                      backgroundColor:
                        errorMessageDispatch !== ' ' ? 'red' : null,
                    }}>
                    <Statistic
                      style={{ textAlign: 'center' }}
                      value={errorMessageDispatch}
                      valueStyle={{
                        fontSize: `${(sizeState / 2.5) * 10}%`,
                        textAlign: 'center',
                        color: 'white',
                      }}
                    />
                  </Col>
                  <Col xs={24} sm={24} lg={sizeState > 30 ? 24 : 8}>
                    <Row>
                      <Col xs={24} sm={24} lg={12}>
                        <Statistic
                          style={{ textAlign: 'center' }}
                          title="Accepted to Warehouse Success :"
                          value={trackingNumberList.length}
                          valueStyle={{
                            fontSize: `${sizeState}0%`,
                            textAlign: 'center',
                            color: 'green',
                          }}
                        />
                      </Col>
                      <Col xs={24} sm={24} lg={12}>
                        <Statistic
                          style={{ textAlign: 'center' }}
                          title="Dispatch Item Error :"
                          value={errorList.length}
                          valueStyle={{
                            fontSize: `${sizeState}0%`,
                            textAlign: 'center',
                            color: 'red',
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Slider
                  defaultValue={50}
                  onChange={e => this.setState({ sizeState: e })}
                />
              </Card>
            </React.Fragment>
          ) : null
        ) : null}
        <Spacer />
        <Card
          title="Tracking Number List"
          extra={`Total: ${trackingNumberList.length}`}
        >
          <ReactTable
            data={trackingNumberList}
            columns={trackingNumberListColumns}
          />
        </Card>
        {successList.length > 0 ? (
          <React.Fragment>
            <Spacer />
            <Card title="Success List" extra={`Total : ${successList.length}`}>
              <ReactTable
                data={successList}
                columns={successColumns}
              />
            </Card>
          </React.Fragment>
        ) : null}
        {errorList.length > 0 ? (
          <React.Fragment>
            <Spacer />
            <Card title="Error List" extra={`Total : ${errorList.length}`}>
              <ReactTable
                data={errorList}
                columns={[
                  {
                    Header: 'Tracking Number',
                    accessor: 'tracking_number',
                  },
                  {
                    Header: 'Message',
                    accessor: 'message',
                  },
                ]}
              />
            </Card>
          </React.Fragment>
        ) : null}
        <Spacer />
        {isFailedStatusRefusal ? (
          <Button
            htmlType="submit"
            type="primary"
            onClick={e => submitHandlerRefusal(e)}
            disabled={trackingNumberList.length === 0}
            block
          >
            <Icon viewBox="0 0 1024 1024">
              <FontAwesomeIcon icon={faPaperPlane} fixedWidth />
            </Icon>
            Submit
          </Button>
        ) : (
          <Button
            htmlType="submit"
            type="primary"
            onClick={this.formSubmit}
            disabled={trackingNumberList.length === 0 || inputDisabled}
            block
          >
            <Icon viewBox="0 0 1024 1024">
              <FontAwesomeIcon icon={faPaperPlane} fixedWidth />
            </Icon>
            Submit
          </Button>
        )}
      </div>
    );
  }
}

StatusTaggingFormTransmittal.defaultProps = {
  cardExtra: null,
  isFailedStatus: false,
  hasDropdownReference: false,
  isFailedStatusRefusal: false,
  hasTransmittalMode: false,
  options: [],
  successList: [],
  hasReceiver: false,
  hasDatePicker: false,
  hasReference: false,
  successColumns: [
    {
      Header: 'Tracking Number',
      accessor: 'tracking_number',
    },
    {
      Header: 'City',
      accessor: 'address_city',
    },
    {
      Header: 'Reference Code',
      accessor: 'status_reference',
    },
    {
      Header: 'Status',
      accessor: 'status',
    },
  ],
};

StatusTaggingFormTransmittal.propTypes = {
  cardExtra: PropTypes.oneOfType([PropTypes.node]),
  form: PropTypes.oneOfType([PropTypes.object]).isRequired,
  trackingNumberList: PropTypes.oneOfType([PropTypes.array]).isRequired,
  trackingNumberListColumns: PropTypes.oneOfType([PropTypes.array]).isRequired,
  errorList: PropTypes.oneOfType([PropTypes.array]).isRequired,
  successList: PropTypes.oneOfType([PropTypes.array]),
  hasDatePicker: PropTypes.bool,
  isFailedStatus: PropTypes.bool,
  hasDropdownReference: PropTypes.bool,
  doPreventDuplicate: PropTypes.bool.isRequired,
  isFailedStatusRefusal: PropTypes.bool,
  options: PropTypes.oneOfType([PropTypes.array]),
  validateHandler: PropTypes.func.isRequired,
  submitHandler: PropTypes.func,
  submitHandlerRefusal: PropTypes.func,
  hasTransmittalMode: PropTypes.bool,
  saveTrackingNumber: PropTypes.bool,
  errorMessageDispatch: PropTypes.string,
  hasReceiver: PropTypes.bool,
  hasReference: PropTypes.bool,
  inputDisabled: PropTypes.bool,
  successColumns: PropTypes.oneOfType([PropTypes.array]),
};

const WrappedStatusTaggingForm = Form.create({ name: 'StatusTaggingForm' })(
  StatusTaggingFormTransmittal,
);
const mapDispatchToProps = {
  doFetchOptionsLike: fetchOptionsLike,
  
};
export default connect(null, mapDispatchToProps)(WrappedStatusTaggingForm);
